export enum TagType {
  Closeable = 'closeable',
  Checkable = 'checkable',
  Default = 'default'
}
